<p-table
	[value]="venueService.subscriptionVenue.value.venueIntegrators"
	[scrollable]="true"
	[rows]="100"
	scrollHeight="500px"
	[virtualScroll]="true"
	[virtualRowHeight]="40"
	[globalFilterFields]="app.keys(venueService.subscriptionVenue.value.venueIntegrators)"
>
	<ng-template pTemplate="header">
		<tr>
			<th pSortableColumn="name">
				Integrator
				<p-sortIcon field="name"></p-sortIcon>
			</th>
			<th>Integration Type</th>
		</tr>
	</ng-template>
	<ng-template let-rec pTemplate="body">
		<tr (click)="selectRecord(rec)" style="height: 40px">
			<td>
				{{ rec.name }}
			</td>
			<td>
				<ng-container *ngFor="let item of rec.integrations">
					{{ app.references.toTitleCase(item) }}
				</ng-container>
			</td>
		</tr>
	</ng-template>
</p-table>
